module.exports = __webpack_public_path__ + "img/暴雨.8f525da4.png";